module.exports = __webpack_public_path__ + "static/media/grid.7f493a60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CanvasEditor/grid.svg
// module id = 683
// module chunks = 0